import React, {useRef, useEffect} from 'react';
import Conf from 'utils/Conf';

const ReactionIcon = ({id, reactions, removeFirstReaction, visible, onDoubleClick}) => {
  const ref = useRef();
  const fire = e => {
    if (visible) {
      let parent = ref.current;
      let node = parent.firstChild.cloneNode();
      parent.appendChild(node);
      node.addEventListener('transitionend', e => {
        if (e.propertyName === 'opacity') e.currentTarget.parentNode.removeChild(e.currentTarget);
      });
      node.style.zIndex = 0;
      node.classList.add('emoji-ready');
      setTimeout(() => node.classList.add('emoji-fire'), 10);
    }
  };
  useEffect(() => {
    reactions &&
      reactions.forEach((r, i) => {
        setTimeout(() => {
          fire();
        }, i * 100);
      });
    return removeFirstReaction();
  }, [reactions]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="emoji-wrapper" ref={ref} onDoubleClick={onDoubleClick}>
      <img className="emoji-img" src={Conf.assetsRoot + '/front/smileys/' + id + '.png'} alt={`${id} emoji`} />
    </div>
  );
};

export default ReactionIcon;
